import { useEffect } from "react";
import { HERO_IMG } from "../lib/images";

const BASE_TITLE = "REFLLEXIVE — Reflexão, Mentalidade e Evolução";
const BASE_DESC = "Para quem quer sair do automático. Reflexões, mentalidade e evolução — um despertar por dia.";

function setMeta(name, content, prop = false) {
  const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    if (prop) el.setAttribute("property", name);
    else el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({ title, description, image } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — REFLLEXIVE` : BASE_TITLE;
    const desc = description || BASE_DESC;
    const img = image || HERO_IMG;
    document.title = fullTitle;
    setMeta("description", desc);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", desc, true);
    setMeta("og:image", img, true);
    setMeta("og:type", "article", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", img);
  }, [title, description, image]);
}
